<a id="livestream-banner" class="banner btn-block callout-banner text-center ga-event" href="/live" (click)="helperService.trackGAEvent('Banner', 'Livestream Banner', 'Dodge Reveal' )">
  <div class="site-wrapper">
    <span class="text-uppercase">
      Watch the Nitrocross racing action live from utah October 5-6 <i class="fa fa-play-circle-o"></i>
    </span>
  </div>
</a>
